import Action from '../../../Action'
import './styles/ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../../../LoadSimple';

import { capitalizeFirstLetter } from '../../../../utils/utils';
import { lang } from '../../../generales/traduction';
const ModalCreateTech =({handleShowPopup,setSearchTerm,languaje,mode,user,dataUsers,devices,server,setRegisterIsValid,groupSelected,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
    const [ManttoData,setManttoData]=useState({name:(editActive)?groupSelected.name:"",visible_name:(editActive)?groupSelected.visible_name:""})
    const [hostName,setHostName]=useState("")
    const [hostLocation,setHostLocation]=useState("")
    const [hostActivate,setHostActivate]=useState(0)

    // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)
    // const dataCriticalities=useFetch('cassia/group_types','','','GET',server)
    // console.log(dataCriticalities)




    const handleChange=(e)=>{
        const {name,value}=e.target
        if(e.target.name==="criticality"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value===""?0:(parseInt(value))
                }
                
            })
        }  else if(e.target.name==="status"){
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value=="Inactivo")?"Activo":"Inactivo"
                }
                
            })
        }else{
            setManttoData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }



        if(e.target.name==="ip"){
            if(value==""){
                setHostLocation("")
                setHostActivate(0)
                setIpValid(true)
                sethost([])
                setHostName("")
                setHostLocation("")
            }else{
                setIpValid(validateIp(value))
            }
           
           
          }
    }

    useEffect(()=>{
     
          if( ManttoData.name=="" || ManttoData.description=="" || IpValid==false || ManttoData.ip==""){
              setDisabled(true)
          }else{
              setDisabled(false)
          }
    },[ManttoData])


    const Registrar=()=>{
        let method='POST'
        let url_add=''
        if(editActive){
            method='PUT'
            // url_add=groupSelected.proxy_id
        }

        let  body ={"dispId": groupSelected.dispId,
  "visible_name":ManttoData.visible_name}


        setLoading(true)
        const fetchDataPost = async () => {
          
       try {
           // console.log(localStorage.getItem('access_token'))
           const response = await fetch(server.url+'/api/v1/cassia/tech_devices/'+url_add, {
             method: method,  
             headers: {
                "Accept": "application/json",
               // 'Content-Type': 'application/json',
               'Content-Type': 'application/json',
                 Authorization: `Bearer ${localStorage.getItem('access_token')}`,
               },
             body: JSON.stringify(body),
           });
           if (response.ok) {
             
             const data1 = await response.json();
             setLoading(false)
             // Manejo de la respuesta
             setData(data1)
            
             handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
             // console.log(data1);
             closCreateCisModal()
           setRegisterIsValid(true)
           
           const timer = setTimeout(() => {
             setRegisterIsValid(false)
             setEditActive(false)
             closCreateCisModal()
           }, 3000);
         
           } else {
             const data1 = await response.json();
             handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
             throw new Error('Error en la solicitud');
           }
       } catch (error) {
              setHostName("")
              setManttoData({type_id:0,name:""})
              
          setLoading(false)
            // Manejo de errores
            setError(error)
            closCreateCisModal()
            setRegisterIsValid(true)
            // handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
            const timer = setTimeout(() => {
              setRegisterIsValid(false)
              setEditActive(false)
              closCreateCisModal()
            }, 3000);
            console.error(error);
          }
        };

        fetchDataPost();
    }

    const buscar_host=(ip)=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'accept': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           //   console.log(response)
           if (response.ok) {
               const data1 = await response.json();
               setLoadingM(false)
               if(data1.data.length==0){
                   sethost([])
               setHostName("")
               setHostLocation("")
               setHostActivate(0)
                   setMsgError("La IP no existe o no esta dada de alta")
                   setIpValid(false)
               }else{
                   setIpValid(true)

               }
               sethost(data1.data)
               setDisabled(true)
           } else {
               const data1 = await response.json();
               throw new Error('Error en la solicitud');
           }
       } catch (error) {
            console.error(error);
          }
        };

        fetchDataPost();
    }
    const changeOption=(option,index)=>{
        setManttoData((prevState)=>{
            return {
                ...prevState,
                ['type_id']:option.value===""?0:(parseInt(option.value))
            }
            
        })
        // setManttoRelation(option.value)
    }

    const [fecha, setDate] = useState('2023-09-28')
    const validateIp= (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            // buscar_host(ip)
        }else{
            setHostLocation("")
            setMsgError("Direccion ip no valida")
            sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
        }
        return result;
    };
    const [resultList,setResultList]=useState([])


    //   console.log(resultList)

    const closeListSearch=()=>{
        setListSearchIP(false)
    }

    const {name,visible_name}=ManttoData;
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {((editActive)?lang[languaje]['editar'].toUpperCase():lang[languaje]['crear'].toUpperCase())+' '+lang[languaje]['grupo'].toUpperCase()}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                                    <div className="form-GS-box"> 
                                    
                                    
                                    
                                    <div className="user-box-GS"  style={{height:'33%'}}>
                                    <input required name="name"  type="text" value={name}
                                    onChange={handleChange} disabled />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['nombre'])}</label>
                                        
                                    </div>
                                   
                                    <div className="user-box-GS"  style={{height:'33%'}}>
                                    <input required name="visible_name"  type="text" value={visible_name}
                                    onChange={handleChange}  />
                                        <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['nombreVisible'])}</label>
                                        
                                    </div>
                                    
                                    
                                   
                                   
                                   
                                    
                                    
                                    <div className="user-box-GS" style={{height:'33%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                            <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Registrar}/>
                                            </>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
    )
}

export default ModalCreateTech